import React from "react";
import { useTranslation } from "react-i18next";
import { Box, BoxVariant } from "../Box";
import { ContentWithTitle } from "../ContentWithTitle";
import { RowWithIconContainer } from "../RowWithIconContainer";
import { Icons } from "../../utils";
import { TextNature } from "../../types";
import { PaymentStatus } from "../../types/paid";

export type IsPaidBannerProps = {
  paymentStatus?: PaymentStatus;
};

export const IsPaidBanner: React.FC<IsPaidBannerProps> = ({
  paymentStatus = PaymentStatus.Paid,
}) => {
  const { t } = useTranslation();

  const isPaidStatus = paymentStatus === PaymentStatus.Paid;

  return (
    <ContentWithTitle title={t("fees")}>
      <Box variant={isPaidStatus ? undefined : BoxVariant.warning}>
        <RowWithIconContainer
          iconName={isPaidStatus ? Icons.successCircle : Icons.warningCircle}
          mainText={isPaidStatus ? t("feesPaid") : t("feesNotPaid")}
          secondaryText={isPaidStatus ? t("feesPaidInfo") : t("feesNotPaidInfo")}
          secondaryTextNature={isPaidStatus ? undefined : TextNature.light}
        />
      </Box>
    </ContentWithTitle>
  );
};
